import React, {Component} from 'react';
import {connect} from 'react-redux'

import HomepageLayout from '../../components/Homepage/index'
import Footer from '../../components/Footer'

class Home extends Component {


    render() {
        return (
            <HomepageLayout heading={true}>
                <Footer/>
            </HomepageLayout>
        );
    }
}



export default connect()(Home)



// WEBPACK FOOTER //
// ./src/scenes/Home/index.js